import React from 'react'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    // En production on pourrait envoyer à un service de monitoring
    console.error('[ErrorBoundary]', error, info)
  }

  handleReload = () => {
    window.location.reload()
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f0fdf8 0%, #e8f7f2 100%)',
          padding: '0 20px',
          textAlign: 'center',
        }}>
          {/* Logo */}
          <div style={{
            width: 64,
            height: 64,
            background: '#1D9E75',
            borderRadius: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: 30,
            fontWeight: 700,
            boxShadow: '0 8px 24px rgba(29,158,117,0.3)',
            marginBottom: 32,
          }}>
            C
          </div>

          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>

          <h1 style={{
            fontSize: 22,
            fontWeight: 700,
            color: '#1a202c',
            margin: '0 0 12px 0',
          }}>
            Une erreur est survenue
          </h1>

          <p style={{
            fontSize: 14,
            color: '#718096',
            maxWidth: 400,
            lineHeight: 1.6,
            margin: '0 0 28px 0',
          }}>
            L'application a rencontré un problème inattendu. Rechargez la page pour continuer.
          </p>

          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{
              background: '#fff5f5',
              border: '1px solid #fed7d7',
              borderRadius: 8,
              padding: '12px 16px',
              fontSize: 12,
              color: '#c53030',
              maxWidth: 560,
              width: '100%',
              textAlign: 'left',
              overflow: 'auto',
              marginBottom: 24,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
            }}>
              {this.state.error.toString()}
            </pre>
          )}

          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={this.handleReset}
              style={{
                background: '#f5f6fa',
                color: '#4a5568',
                border: '1.5px solid #e2e8f0',
                borderRadius: 10,
                padding: '11px 24px',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Réessayer
            </button>
            <button
              onClick={this.handleReload}
              style={{
                background: '#1D9E75',
                color: 'white',
                border: 'none',
                borderRadius: 10,
                padding: '11px 24px',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                boxShadow: '0 4px 14px rgba(29,158,117,0.35)',
              }}
            >
              Recharger la page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
